import styled from 'styled-components'

import CommonStyledButton from '../common/styled/StyledButton'
import CommonStyledInput from '../common/styled/StyledInput'
import CommonStyledLink from '../common/styled/StyledLink'

export const StyledButton = styled(CommonStyledButton)``
export const StyledInput = styled(CommonStyledInput)``
export const StyledLink = styled(CommonStyledLink)``
